<template>
  <div class="app-wrapper">
    <div class="header" v-if="scrollShow">
      <div class="header-left">
        <img
          class="logo"
          src="../../../../static/image/logo/black-logo1.png"
          alt=""
        />
        <p class="expand iconfont icon-shangyibu1" @click="hideNav"></p>
      </div>

      <p class="header-title">WUPEN CMS</p>

      <div class="user">
        <p class="iconfont">&#xe619;</p>
        <div class="user-info">
          <p>{{ userInfo.name }}</p>
          <p>欢迎回来！</p>
        </div>
      </div>
    </div>

    <div class="sidebar-container" :class="hide ? 'isShow' : ''">
      <el-menu
        :show-timeout="200"
        :collapse="false"
        mode="vertical"
        active-text-color="#409EFF"
        class="menu-container"
        @select="goPage"
      >
        <template v-for="(item, index) in showData">
          <el-menu-item
            :index="index + ''"
            :key="index"
            v-if="item.page"
            class="main-tab"
          >
            <i :class="item.isicon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>

          <el-submenu :index="index + ''" :key="index" v-if="!item.page">
            <template slot="title">
              <i :class="item.isicon"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item
              :index="index + '-' + index1"
              v-for="(item1, index1) in item.data"
              :key="index1"
            >
              <span slot="title">{{ item1[0] }}</span>
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </div>
    <div class="main-container" :class="hide ? '' : 'expland'">
      <section class="app-main">
        <transition name="fade-transform" mode="out-in">
          <router-view />
        </transition>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      userPermission: [{}],
      userInfo: {},
      scrollShow: true,
      hide: false,
      showData: [],
      data: [
        {
          name: "首页",
          isicon: "el-icon-s-home",
          page: "AdminMain",
          data: [],
          code: "a1",
        },

        // 展览
        {
          name: "展览管理",
          isicon: "el-icon-office-building", // 随机的icon
          data: [
            ["展览列表", "ExhibitionList"],
            ["作品列表", "WorksList"],
            ["其他", "OtherList"],
          ],
          en_name: "exhibition_management",
          code: "a4",
        },

        // 用户管理
        {
          name: "用户管理",
          isicon: "el-icon-s-custom",
          data: [
            ["用户列表", "UserList"],
            ["群体画像", "GroupPortrait"],
          ],
          code: "a1",
          en_name: "account_management",
        },
        // 院校
        {
          name: "院校管理",
          isicon: "el-icon-office-building",
          code: "University",
          data: [
            ["院校列表", "school"],
            ["院校排行榜", "rinkingschool"],
          ],
          code: "a2",
          en_name: "univeristy_management",
        },
        // 学者
        {
          name: "学者管理",
          isicon: "el-icon-user-solid",
          data: [["学者列表", "scholarlist"]],
          code: "a3",
          en_name: "scholar_management",
        },
        // exploration
        {
          name: "前沿管理",
          isicon: "el-icon-discover",
          data: [["前沿动态", "explorationlist"]],
          code: "a6",
          en_name: "exploration_management",
        },
        // bp
        {
          name: "BP管理",
          isicon: "el-icon-s-opportunity",
          data: [["BP列表", "bestpractice"]],
          code: "a7",
          en_name: "bp_management",
        },
        // 竞赛
        {
          name: "竞赛管理",
          isicon: "el-icon-medal-1",
          data: [
            // ["竞赛列表", "CompetitionList"],
            // ["竞赛作品", "CompetitionWork"],
            ["竞赛列表", "newCompetitionList"],
          ],
          code: "a8",
          en_name: "competition_management",
        },
        //  新闻管理
        {
          name: "新闻管理",
          isicon: "el-icon-s-promotion",
          data: [["新闻列表", "News"]],
          en_name: "news_management",
          code: "a9",
        },
        // GuiHua
        {
          name: "GUIHUA",
          isicon: "el-icon-collection",
          data: [
            ["杂志管理", "newMagazine"],
            ["Banner管理", "magazineBanner"],
            ["编委信息", "magazineScholarList"],
            ["网页文本管理", "magazineRichText"],
            ["周报管理", "newsLatterList"],
          ],
          code: "b1",
          en_name: "guihua_management",
        },

        //审核管理员
        {
          name: "内容审核",
          isicon: "el-icon-video-camera-solid",
          data: [["Urban Dream", "urbanDream"]],
          code: "b2",
          en_name: "ub_management",
        },
        // 课程管理 courseManagement
        {
          name: "课程管理",
          isicon: "el-icon-reading",
          data: [
            ["课程列表", "lecture"],
            ["Banner管理", "lecturebanner"],
          ],
          en_name: "lecture_management",
          code: "a4",
        },
        // 地图
        {
          name: "地图管理",
          isicon: "el-icon-location",
          data: [
            ["城市群列表", "regionList"],
            ["城市列表", "cityList"],
          ],
          code: "a5",
          en_name: "city_management",
        },
        {
          name: "词条管理",
          isicon: "el-icon-notebook-1",
          data: [["词条列表", "EntryList"]],
          en_name: "entry_management",
          code: "b7",
        },

        {
          name: "山西遗产管理",
          isicon: "el-icon-guide",
          data: [
            ["遗产列表", "HeritageList"],
            ["城市与合作", "HeritageCity"],
          ],
          en_name: "heritage_management",
          code: "c1",
        },

        {
          name: "内容管理",
          isicon: "el-icon-s-tools",
          data: [
            ["NewBanner管理", "BannerManage"],
            ["词库管理", "thesaurusManagement"],
            // ["富文本信息", "RichText"],
            // ["内容字典管理", "Dictionary"],
            // ["竞赛字典管理", "CompetitionDictionary"],
            // ["用户管理", "User", "el-icon-menu"], // b5 "permission_management"
            // ["角色管理", "Role", "el-icon-menu"],
          ],
          code: "b8",
        },
      ],
    };
  },
  mounted() {
    // window.addEventListener("scroll", this.windowScroll);
  },
  created() {
    this.setShowData();
  },
  methods: {
    windowScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 840) {
        this.scrollShow = false;
      } else {
        this.scrollShow = true;
      }
    },
    setShowData() {
      const roleData = this.$global.getPermission();
      console.log(roleData);
      this.data.forEach((menu) => {
        if (menu.code == "") {
          this.showData.push(menu);
        }
        roleData.forEach((page) => {
          if (menu.code != "b4") {
            if (page.module_id == menu.code) {
              this.showData.push(menu);
            }
          } else {
            if (!roleData.find((item) => item.module_id == menu.code)) {
              this.showData.push(menu);
            }
          }
        });
      });

      console.log(this.showData);
    },
    goPage(key) {
      console.log(key);
      const temp = key.split("-");
      if (temp.length > 1) {
        //选择子项
        this.selectData = this.showData[temp[0]].data[temp[1]];
        this.$router.push({ name: this.selectData[1] });
      } else {
        this.selectData = this.showData[temp[0]].name;
        this.$router.push({ name: this.showData[temp[0]].page });
      }
    },
    logout() {
      // this.$global.logout()
      this.$router.push({ name: "AdminLogin" });
    },
    hideNav() {
      this.hide = !this.hide;
    },
    // 选中
    choice(key, ss) {
      if (this.data[key].name == "BP管理") {
        this.showData[
          key
        ].isicon = require("../../../../static/image/userManagement/bpChoice.svg");
      }
    },
    notChoice(key) {
      if (this.data[key].name == "BP管理") {
        this.showData[
          key
        ].isicon = require("../../../../static/image/userManagement/bp.svg");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  .header {
    display: flex;
    background: white;
    border-bottom: 2px solid $timeBtn;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1000;
    top: 0px;
    min-width: 500px;
    .header-left {
      display: flex;
      align-items: center;
      height: 50px;
      background: $timeBtn;
      width: 180px;
      .logo {
        margin-left: 20px;
        height: 40px;
        cursor: pointer;
      }
      .expand {
        height: 30px;
        width: 30px;
        background: rgb(2, 62, 173);
        color: white;
        cursor: pointer;
        border-radius: 5px;
        line-height: 30px;
        text-align: center;
        margin-left: 20px;
      }
      .expand:hover {
        color: $lightenYellow;
      }
    }
    .header-title {
      font-family: $chinese;
      font-size: 15px;
      font-weight: bold;
      color: $timeBtn;
      line-height: 50px;
    }
    .user {
      width: 180px;
      display: flex;
      align-items: center;
      padding-left: 30px;
      height: 50px;
      .iconfont {
        font-size: 32px;
        margin-right: 10px;
        color: $timeBtn;
      }
      .user-info {
        text-align: left;
        p:nth-of-type(1) {
          font-size: 12px;
          line-height: 14px;
          margin-top: 5px;
          color: $timeBtn;
        }
        p:nth-of-type(2) {
          font-size: 10px;
          line-height: 14px;

          color: $timeBtn;
        }
      }
    }
  }

  .sidebar-container::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: $lightenYellow;
  }
  .sidebar-container::-webkit-scrollbar {
    width: 4px;
  }
  .sidebar-container {
    padding-top: 20px;
    border-left: none;
    box-shadow: $shadow;
    height: calc(100% - 50px);
    transition: width 0.28s;
    width: 180px !important;
    position: fixed;
    font-size: 0px;
    top: 50px;
    bottom: 0;
    left: 0;
    background-color: $timeBtn;
    z-index: 1001;
    overflow: hidden;
    overflow-y: auto;
    /deep/ .el-menu {
      border: none;
      background-color: $timeBtn;
      width: 170px !important;
      box-sizing: border-box;
    }
    .main-tab {
      margin: 0px !important;
      line-height: 40px !important;
      height: 40px !important;
    }
    /deep/ .el-menu-item {
      font-size: 12px;
      margin: 5px 5px 5px 0px;
      min-width: 160px;
      line-height: 30px;
      height: 30px;
      color: $base-color !important;
      border-radius: 0px 5px 5px 0px;
      img {
        width: 16px;
        margin-right: 5px;
      }
      i {
        color: white;
      }
    }

    /deep/ .el-menu--inline {
      .el-menu-item {
        padding-left: 60px !important;
        width: 160px;
      }
    }
    /deep/ .is-active {
      color: $lightenYellow !important;
      background-color: $timeBtn !important;
    }
    /deep/ .is-opened {
      width: 170px;
      border-radius: 0px 5px 5px 5px !important;
      .el-submenu__title {
        background-color: rgb(2, 62, 173) !important;
      }
    }
    /deep/ .el-menu-item:hover,
    /deep/ .el-submenu__title:hover {
      background-color: $lightenYellow !important;
      color: $base-color !important;
    }
    /deep/ .el-submenu__title {
      width: 170px;
      height: 40px;
      font-size: 12px;
      line-height: 40px;
      color: $base-color !important;
      border-radius: 0px 5px 5px 0px;
      img {
        width: 16px;
        margin-right: 5px;
      }
      i {
        color: white;
      }
    }
    /deep/ .el-menu--inline {
      color: $base-color !important;
    }
  }
  .isShow {
    width: 0 !important;
  }
  .main-container {
    top: 50px;
    width: 100%;
    min-width: 1220px;
    position: relative;
    transition: all 0.28s;
    padding: 0px 40px 100px;
    .app-main {
      position: relative;
      height: calc(100% - 50px);
    }
  }
  .expland {
    margin-left: 180px;
    transition: all 0.28s;
    width: calc(100% - 180px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/layout/Layout.vue